import { render, staticRenderFns } from "./threeDimMultiPlayer.vue?vue&type=template&id=3cf933a1&scoped=true"
import script from "./threeDimMultiPlayer.vue?vue&type=script&lang=js"
export * from "./threeDimMultiPlayer.vue?vue&type=script&lang=js"
import style0 from "./threeDimMultiPlayer.vue?vue&type=style&index=0&id=3cf933a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf933a1",
  null
  
)

export default component.exports